import { RouteRecordRaw } from 'vue-router';
import Overview from '@/views/dashboard/overview/Index.vue';
import Dashboard from '@/views/dashboard/Index.vue';
import Auth from '@/views/auth/Index.vue';
import PigsParentView from '@/views/dashboard/pigs/Index.vue';
import PigsStatus from '@/views/dashboard/pigs/pigsStatus/Index.vue';
import PigsInsertions from '@/views/dashboard/pigs/pigsInsertions/Index.vue';
import PigsTransfers from '@/views/dashboard/pigs/pigsTransfers/Index.vue';
import PigsDeaths from '@/views/dashboard/pigs/pigsDeaths/Index.vue';
import PigsSold from '@/views/dashboard/pigs/pigsSold/Index.vue';
import PigsSlaughters from '@/views/dashboard/pigs/pigsSlaughters/Index.vue';
import PigsStatusRecords from '@/views/dashboard/pigs/pigsStatusRecords/Index.vue';
import PigsBatches from '@/views/dashboard/pigs/pigsBatches/Index.vue';
import Production from '@/views/dashboard/production/Index.vue';
import Hitlist from '@/views/dashboard/hitlist/Index.vue';
import Debug from '@/views/dashboard/debug/Index.vue';
import EconomyParentView from '@/views/dashboard/economy/Index.vue';
import EconomyMain from '@/views/dashboard/economy/economyMain/Index.vue';
import EconomyPostPayments from '@/views/dashboard/economy/economyPostPayments/Index.vue';
import EconomyListings from '@/views/dashboard/economy/economyListings/Index.vue';
import EconomyDeaths from '@/views/dashboard/economy/economyDeaths/Index.vue';
import EconomyStatus from '@/views/dashboard/economy/economyStatus/Index.vue';
import EconomyBudget from '@/views/dashboard/economy/economyBudget/Index.vue';
import Reports from '@/views/dashboard/reports/Index.vue';
import ReportsParentView from '@/views/dashboard/reports/ParentView.vue';
import FeedReconciliations from '@/views/dashboard/feed/feedReconciliations/Index.vue';
import FarmToFarm from '@/views/dashboard/reports/farmToFarm/Index.vue';
import Slaughters from '@/views/dashboard/slaughters/Index.vue';
import FeedParentView from '@/views/dashboard/feed/Index.vue';
import FeedMixes from '@/views/dashboard/feed/feedMixes/Index.vue';
import FeedConsumptionData from '@/views/dashboard/feed/feedConsumptionData/Index.vue';
import FeedRawMaterials from '@/views/dashboard/feed/feedRawMaterials/Index.vue';
import FeedDeliveries from '@/views/dashboard/feed/feedDeliveries/Index.vue';
import FeedConsumption from '@/views/dashboard/feed/feedConsumption/Index.vue';
import HealthParentView from '@/views/dashboard/health/Index.vue';
import HealthOverview from '@/views/dashboard/health/healthOverview/Index.vue';
import HealthInstructions from '@/views/dashboard/health/instructions/Index.vue';
import HealthInventory from '@/views/dashboard/health/inventory/Index.vue';
import HealthInventoryLog from '@/views/dashboard/health/inventory/log/Index.vue';
import HealthInventoryStatement from '@/views/dashboard/health/inventory/report/Index.vue';
import HealthInventoryDetail from '@/views/dashboard/health/inventory/detail/Index.vue';
import SettingsParentView from '@/views/dashboard/settings/Index.vue';
import KPIs from '@/views/dashboard/settings/kpis/Index.vue';
import Cookies from '@/views/dashboard/settings/cookies/Index.vue';
import Locations from '@/views/dashboard/settings/locations/Index.vue';
import Users from '@/views/dashboard/settings/users/Index.vue';
import Directories from '@/views/dashboard/settings/directories/Index.vue';
import Setup from '@/views/dashboard/settings/setup/Index.vue';
import PasswordReset from '@/views/auth/passwordReset/Index.vue';
import ForgotPassword from '@/views/auth/forgotPassword/Index.vue';
import Login from '@/views/auth/logIn/Index.vue';
import NotificationsParentView from '@/views/dashboard/notifications/Index.vue';
import NotificationsIndex from '@/views/dashboard/notifications/notificationsIndex/Index.vue';
import Notes from '@/views/dashboard/notes/Index.vue';
import Assignments from '@/views/dashboard/assignments/Index.vue';
import GenericActivityView from '@/views/dashboard/generics/ActivityView.vue';
import MonitoringView from '@/views/dashboard/monitoring/Index.vue';
import MonitoringMain from '@/views/dashboard/monitoring/monitoring/Index.vue';
import AlarmLog from '@/views/dashboard/monitoring/log/Index.vue';
import { ActivityTableRecordType, Module, IconSource } from '@/types';
import OverviewParentView from '@/views/dashboard/overview/ParentView.vue';
import DataQuality from '@/views/dashboard/overview/data-quality/Index.vue';
import DataQualityHistory from '@/views/dashboard/overview/data-quality/HistoryView.vue';
import Objectives from '@/views/dashboard/overview/objectives/Index.vue';
import WeekOverview from '@/views/dashboard/overview/week-overview/Index.vue';
import Analysis from '@/views/dashboard/analysis/Index.vue';
import GroupOverview from '@/views/dashboard/monitoring/group-overview/Index.vue';
import ActiveGroups from '@/views/dashboard/monitoring/active-groups/Index.vue';
import MonitoringUnlock from '@/views/dashboard/monitoring/unlock/Index.vue';

export const routes: RouteRecordRaw[] = [
    {
        path: '/auth',
        name: 'Auth',
        component: Auth,
        children: [
            {
                path: '/auth/login',
                name: 'Login',
                component: Login,
            },
            {
                path: '/auth/forgot',
                name: 'ForgotPassword',
                component: ForgotPassword,
            },
            {
                path: '/auth/reset',
                name: 'PasswordReset',
                component: PasswordReset,
            },
        ],
    },
    {
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        redirect: '/overview',
        meta: { appearsInSidebar: false },
        children: [
            {
                path: '/settings',
                name: 'Settings',
                component: SettingsParentView,
                meta: { appearsInSidebar: false },
                children: [
                    {
                        path: '/settings/kpis',
                        name: 'Kpis',
                        component: KPIs,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/settings/cookies',
                        name: 'Cookies',
                        component: Cookies,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/settings/locations',
                        name: 'Locations',
                        component: Locations,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/settings/users',
                        name: 'Users',
                        component: Users,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/settings/companies',
                        name: 'Directories',
                        component: Directories,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/settings/setup',
                        name: 'Setup',
                        component: Setup,
                        meta: { appearsInSidebar: false },
                    },
                ],
            },
            {
                path: '/notifications',
                name: 'Notifications',
                component: NotificationsParentView,
                meta: { appearsInSidebar: false },
                children: [
                    {
                        path: '/notifications',
                        name: 'NotificationsIndex',
                        component: NotificationsIndex,
                        meta: { appearsInSidebar: false },
                    },
                ],
            },
            {
                path: '/monitoring',
                name: 'Monitoring',
                component: MonitoringView,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 1,
                    sidebarText: 'layouts.dashboard.sideBar.routes.monitoring.main',
                    sidebarActiveIcon: IconSource.NavMonitoringActive,
                    sidebarInactiveIcon: IconSource.NavMonitoringInactive,
                    requiresModule: Module.RealTime,
                },
                children: [
                    {
                        path: '',
                        name: 'MonitoringMain',
                        component: MonitoringMain,
                        meta: { appearsInSidebar: false, requiresModule: Module.RealTime },
                    },
                    {
                        // requiresModule is sidebar-visibility only: the Monitoring parent already requires RealTime,
                        // so this adds ProductionGroup on top. The page has no page-level gate and the
                        // monitor/production-groups endpoints do no module or role check, so reaching the URL
                        // without the module still loads data.
                        path: '/monitoring/active-groups',
                        name: 'ActiveGroups',
                        component: ActiveGroups,
                        meta: {
                            appearsInSidebar: true,
                            sidebarText: 'layouts.dashboard.sideBar.routes.monitoring.activeGroups',
                            requiresModule: Module.ProductionGroup,
                        },
                    },
                    {
                        // The same page with its Section detail overlay open, so a Section's
                        // Productivity Chart can be linked to, reloaded and reached with the back
                        // button. Deliberately the same component rather than a child route: the
                        // overlay is drawn over the grid it came from and needs that grid's data
                        // (rows for prev/next, the barn's Production Groups) already loaded, and routing
                        // to the same component reuses the instance instead of remounting it.
                        // The chart's own view state - granularity, range, comparison - travels as
                        // query parameters on this route; only the Section is part of its identity.
                        path: '/monitoring/active-groups/:sectionId(\\d+)',
                        name: 'ActiveGroupsDetail',
                        component: ActiveGroups,
                        meta: {
                            // Sidebar already lists the grid above; this is the same destination
                            // with one Section open, not a second place to go.
                            appearsInSidebar: false,
                            // requiresModule is sidebar-visibility only here, and must stay equal to
                            // the ActiveGroups record above. No page-level gate stands behind it and
                            // the endpoints do no module or role check, so reaching this URL
                            // without the module still loads data.
                            requiresModule: Module.ProductionGroup,
                        },
                    },
                    {
                        // requiresModule is sidebar-visibility only. The page has no page-level gate and the
                        // monitor/production-groups endpoints do no module or role check, so reaching the URL
                        // without the module still loads data (and the write actions stay callable).
                        path: '/monitoring/group-overview',
                        name: 'GroupOverview',
                        component: GroupOverview,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.monitoring.groupOverview', requiresModule: Module.ProductionGroup },
                    },
                    {
                        path: '/monitoring/log',
                        name: 'AlarmLog',
                        component: AlarmLog,
                        meta: {
                            appearsInSidebar: true,
                            sidebarText: 'layouts.dashboard.sideBar.routes.monitoring.alarmLog',
                            requiresModule: Module.RealTime,
                        },
                    },
                ],
            },
            {
                path: '/monitoring/unlock',
                name: 'MonitoringUnlock',
                component: MonitoringUnlock,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 1,
                    sidebarText: 'layouts.dashboard.sideBar.routes.monitoring.unlock',
                    sidebarActiveIcon: IconSource.NavMonitoringInactive,
                    sidebarInactiveIcon: IconSource.NavMonitoringInactive,
                    hideIfNotGetter: 'realtimeModuleDisabled',
                },
            },
            {
                path: '/notes',
                name: 'Notes',
                component: Notes,
                meta: { appearsInSidebar: false, requiresModule: Module.RealTime },
            },
            {
                path: '/assignments',
                name: 'Assignments',
                component: Assignments,
                meta: { appearsInSidebar: false, requiresModule: Module.Assignments },
            },
            {
                path: '/analysis',
                name: 'Analysis',
                component: Analysis,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 1,
                    sidebarText: 'layouts.dashboard.sideBar.routes.analysis',
                    sidebarActiveIcon: IconSource.NavAnalysisActive,
                    sidebarInactiveIcon: IconSource.NavAnalysisInactive,
                    requiresModule: Module.Analysis,
                },
            },
            {
                path: '/overview',
                name: 'OverviewView',
                component: OverviewParentView,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.overview',
                    sidebarActiveIcon: IconSource.NavStatusActive,
                    sidebarInactiveIcon: IconSource.NavStatusInactive,
                },
                children: [
                    {
                        path: '',
                        name: 'Overview',
                        component: Overview,
                        meta: {
                            sidebarText: 'layouts.dashboard.sideBar.routes.overview',
                        },
                    },
                    {
                        path: '/overview/objectives',
                        name: 'Objectives',
                        component: Objectives,
                        meta: {
                            appearsInSidebar: true,
                            sidebarText: 'layouts.dashboard.sideBar.routes.objectives',
                            // Single gate: SolutionAdmin role only - no module grant involved.
                            // Employee/Advisor/DirectoryAdmin never see this in the sidebar.
                            // Frontend-only, same as every other hideIfNotGetter route below - no
                            // server-side check backs this.
                            hideIfNotGetter: 'loggedInUserCanManageSolution',
                            adminOnly: true,
                        },
                    },
                    {
                        path: '/overview/data-quality',
                        name: 'DataQuality',
                        component: DataQuality,
                        meta: {
                            appearsInSidebar: true,
                            sidebarText: 'layouts.dashboard.sideBar.routes.dataQuality',
                            requiresModule: Module.DataQualityAssessment,
                        },
                    },
                    {
                        path: '/overview/data-quality/history',
                        name: 'DataQualityHistory',
                        component: DataQualityHistory,
                        meta: {
                            requiresModule: Module.DataQualityAssessment,
                        },
                    },
                    {
                        path: '/overview/week-overview',
                        name: 'WeekOverview',
                        component: WeekOverview,
                        meta: {
                            appearsInSidebar: true,
                            sidebarText: 'layouts.dashboard.sideBar.routes.weekOverview',
                            // Beta: shown to SolutionAdmins, OR to anyone in a directory/user assigned the temporary
                            // WeekOverviewBeta module (accessMode 'any' - the two gates are alternatives here, not both
                            // required like on other routes). Frontend-only, no server-side check backs this; the API
                            // only validates farm access.
                            hideIfNotGetter: 'loggedInUserCanManageSolution',
                            requiresModule: Module.WeekOverviewBeta,
                            accessMode: 'any',
                            beta: true,
                        },
                    },
                ],
            },
            {
                path: '/activity',
                name: 'Activity',
                component: GenericActivityView,
                props: { recordTypeIds: Object.values(ActivityTableRecordType).filter((currentKey) => !Number.isNaN(Number(currentKey))), heading: 'views.activity.header.heading' },
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.activity',
                    sidebarActiveIcon: IconSource.NavActivityActive,
                    sidebarInactiveIcon: IconSource.NavActivityInactive,
                },
            },
            {
                path: '/production',
                name: 'Production',
                component: Production,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.production',
                    sidebarActiveIcon: IconSource.NavProductionDataActive,
                    sidebarInactiveIcon: IconSource.NavProductionDataInactive,
                },
            },
            {
                path: '/pigs',
                name: 'Pigs',
                component: PigsParentView,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.pigs.main',
                    sidebarActiveIcon: IconSource.NavPigsActive,
                    sidebarInactiveIcon: IconSource.NavPigsInactive,
                },
                children: [
                    {
                        path: '',
                        name: 'PigsStatus',
                        component: PigsStatus,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/pigs/activities',
                        name: 'PigsActivities',
                        component: GenericActivityView,
                        props: {
                            recordTypeIds: [
                                ActivityTableRecordType.Insertion,
                                ActivityTableRecordType.Slaughter,
                                ActivityTableRecordType.Dead,
                                ActivityTableRecordType.Status,
                                ActivityTableRecordType.Departure,
                                ActivityTableRecordType.Transfer,
                                ActivityTableRecordType.PreSlaughter,
                            ],
                            heading: 'views.pigs.activities.header.heading',
                        },
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.pigs.activities' },
                    },
                    {
                        path: '/pigs/insertions',
                        name: 'PigsInsertions',
                        component: PigsInsertions,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.pigs.insertions' },
                    },
                    {
                        path: '/pigs/transfers',
                        name: 'PigsTransfers',
                        component: PigsTransfers,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.pigs.transfers' },
                    },
                    {
                        path: '/pigs/deaths',
                        name: 'PigsDeaths',
                        component: PigsDeaths,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.pigs.deaths' },
                    },
                    {
                        path: '/pigs/sold',
                        name: 'PigsSold',
                        component: PigsSold,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.pigs.sold' },
                    },
                    {
                        path: '/pigs/slaughters',
                        name: 'PigsSlaughters',
                        component: PigsSlaughters,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.pigs.slaughters' },
                    },
                    {
                        // Named PigsStatusRecords, not PigsStatus: that NAME already belongs to the
                        // hidden Pigs-section landing page above (path '', which resolves to '/pigs'
                        // itself) - an unrelated page. The path '/pigs/status-records' itself was
                        // free either way; this is the Records submenu for status registrations.
                        path: '/pigs/status-records',
                        name: 'PigsStatusRecords',
                        component: PigsStatusRecords,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.pigs.statusRecords' },
                    },
                    {
                        path: '/pigs/batches',
                        name: 'PigsBatches',
                        component: PigsBatches,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.pigs.batches', hideIfNotGetter: 'directoryHasBatchBarns' },
                    },
                ],
            },
            {
                path: '/feed',
                name: 'Feed',
                component: FeedParentView,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.feed.main',
                    sidebarActiveIcon: IconSource.NavFoodActive,
                    sidebarInactiveIcon: IconSource.NavFoodInactive,
                },
                children: [
                    {
                        path: '',
                        name: 'FeedConsumptionData',
                        component: FeedConsumptionData,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/feed/raw-materials',
                        name: 'FeedRawMaterials',
                        component: FeedRawMaterials,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.feed.rawMaterials' },
                    },
                    {
                        path: '/feed/mixes',
                        name: 'FeedMixes',
                        component: FeedMixes,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.feed.mix' },
                    },
                    {
                        path: '/feed/deliveries',
                        name: 'FeedDeliveries',
                        component: FeedDeliveries,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.feed.deliveries' },
                    },
                    {
                        path: '/feed/consumption',
                        name: 'FeedConsumption',
                        component: FeedConsumption,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.feed.consumption' },
                    },
                ],
            },
            {
                path: '/health',
                name: 'Health',
                component: HealthParentView,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.health.main',
                    sidebarActiveIcon: IconSource.MedicineActive,
                    sidebarInactiveIcon: IconSource.MedicineInactive,
                    requiresModule: Module.Medicine,
                },
                children: [
                    {
                        path: '',
                        name: 'HealthOverview',
                        component: HealthOverview,
                        meta: { appearsInSidebar: false, requiresModule: Module.Medicine },
                    },
                    {
                        path: '/health/instructions',
                        name: 'HealthInstructions',
                        component: HealthInstructions,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.health.instructions', requiresModule: Module.Medicine },
                    },
                    {
                        path: '/health/inventory',
                        component: HealthParentView,
                        // Beta: shown only with the temporary MedicineInventoryBeta module, on top of Medicine required by Health above. Sidebar-only like every
                        // requiresModule here: the pages list only the current directory's own stock, and every read and write is authorised by the API.
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.health.inventory', requiresModule: Module.MedicineInventoryBeta, beta: true },
                        children: [
                            {
                                path: '',
                                name: 'HealthInventory',
                                component: HealthInventory,
                                // requiresModule is sidebar-only here: the pages list only the current directory's own stock, and every read and write is authorised by the API.
                                meta: { appearsInSidebar: false, requiresModule: Module.MedicineInventoryBeta },
                            },
                            {
                                path: '/health/inventory/log',
                                name: 'HealthInventoryLog',
                                component: HealthInventoryLog,
                                // requiresModule is sidebar-only here: the pages list only the current directory's own stock, and every read and write is authorised by the API.
                                meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.health.inventoryLog', requiresModule: Module.MedicineInventoryBeta },
                            },
                            {
                                path: '/health/inventory/statement',
                                name: 'HealthInventoryStatement',
                                component: HealthInventoryStatement,
                                // requiresModule is sidebar-only here: the pages list only the current directory's own stock, and every read and write is authorised by the API.
                                meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.health.inventoryReport', requiresModule: Module.MedicineInventoryBeta },
                            },
                        ],
                    },
                    {
                        // A destination in its own right (shareable, reloadable, back-navigable): the ledger key is the page's identity, not state the list could hold.
                        path: '/health/inventory/:farmId/:drugId/:unitId',
                        name: 'HealthInventoryDetail',
                        component: HealthInventoryDetail,
                        // requiresModule is sidebar-only here: nothing in the page renders without data the API authorises per farm.
                        meta: { appearsInSidebar: false, requiresModule: Module.MedicineInventoryBeta, sidebarActivePath: '/health/inventory' },
                    },
                ],
            },
            {
                path: '/economy',
                name: 'Economy',
                component: EconomyParentView,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.economy.main',
                    sidebarActiveIcon: IconSource.NavEconomyActive,
                    sidebarInactiveIcon: IconSource.NavEconomyInactive,
                },
                children: [
                    {
                        path: '',
                        name: 'EconomyMain',
                        component: EconomyMain,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/economy/budget',
                        name: 'EconomyBudget',
                        component: EconomyBudget,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.economy.budget' },
                    },
                    {
                        path: '/economy/status',
                        name: 'EconomyStatus',
                        component: EconomyStatus,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.economy.status', requiresModule: Module.StatusEntries },
                    },
                    {
                        path: '/economy/bonus-payments',
                        name: 'EconomyPostPayments',
                        component: EconomyPostPayments,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.economy.postPayments', requiresModule: Module.BonusPayments },
                    },
                    {
                        path: '/economy/listings',
                        name: 'EconomyListings',
                        component: EconomyListings,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.economy.listings', requiresModule: Module.PriceListings },
                    },
                    {
                        path: '/economy/deaths',
                        name: 'EconomyDeaths',
                        component: EconomyDeaths,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.economy.deaths' },
                    },
                ],
            },
            {
                path: '/slaughters',
                name: 'Slaughters',
                component: Slaughters,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.slaughters',
                    sidebarActiveIcon: IconSource.NavSlaughtersActive,
                    sidebarInactiveIcon: IconSource.NavSlaughtersInactive,
                },
            },
            {
                path: '/makeable',
                name: 'Debug',
                component: Debug,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.debug',
                    sidebarActiveIcon: IconSource.NavProductionDataActive,
                    sidebarInactiveIcon: IconSource.NavProductionDataInactive,
                    requiresModule: Module.Debug,
                },
            },
            {
                path: '/reports',
                name: 'Reports',
                component: ReportsParentView,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.reports',
                    sidebarActiveIcon: IconSource.NavReportsActive,
                    sidebarInactiveIcon: IconSource.NavReportsInactive,
                },
                children: [
                    {
                        path: '',
                        name: 'ReportsIndex',
                        component: Reports,
                        meta: { appearsInSidebar: false },
                    },
                    {
                        path: '/feed/reconciliations',
                        name: 'FeedReconciliations',
                        component: FeedReconciliations,
                        meta: { appearsInSidebar: true, sidebarText: 'layouts.dashboard.sideBar.routes.reportsFeedReconciliation' },
                    },
                    {
                        // Available for all but signaled as beta
                        path: '/reports/farm-to-farm',
                        name: 'FarmToFarm',
                        component: FarmToFarm,
                        meta: {
                            appearsInSidebar: true,
                            sidebarText: 'layouts.dashboard.sideBar.routes.reportsFarmToFarm',
                            beta: true,
                        },
                    },
                ],
            },
            {
                path: '/hitlist',
                name: 'Hitlist',
                component: Hitlist,
                meta: {
                    appearsInSidebar: true,
                    sidebarGroup: 3,
                    sidebarText: 'layouts.dashboard.sideBar.routes.hitlist',
                    sidebarActiveIcon: IconSource.NavHitlistActive,
                    sidebarInactiveIcon: IconSource.NavHitListInactive,
                    requiresModule: Module.Hitlist,
                },
            },
        ],
    },
];
